import { render, staticRenderFns } from "./CabeceraModalEdicion.vue?vue&type=template&id=135055e3&scoped=true&"
import script from "./CabeceraModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalEdicion.vue?vue&type=style&index=0&id=135055e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135055e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('135055e3', component.options)
    } else {
      api.reload('135055e3', component.options)
    }
    module.hot.accept("./CabeceraModalEdicion.vue?vue&type=template&id=135055e3&scoped=true&", function () {
      api.rerender('135055e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ConfigAutorizaciones/CabeceraModalEdicion.vue"
export default component.exports